module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/chapel_02-503e223d2b0831c3b7514515ec0fee05.jpg";